import { useEffect, useState } from 'react';
import type { IBaseViewModel } from '@/engine/app/interfaces';
import type { ViewsService } from '@/engine/app/Views.service.ts';
import { useInjection } from 'inversify-react';
import { TYPES } from '@/engine/ioc';
import type { WorkflowIndicationsResolver } from '@/components/boxes/indicationsBoxes/workflowIndications/workflowIndicationsResolver.ts';

export const useWorkflowIndication = (): { indicationsWithLabels: Array<[IBaseViewModel, string]> } => {
  const { currentView }: ViewsService = useInjection<ViewsService>(TYPES.ViewsService);
  const workflowIndicationsResolver = useInjection<WorkflowIndicationsResolver>(TYPES.WorkflowIndicationsResolver);

  if (!currentView) {
    throw new Error('View should be defined by current step');
  }

  const [indicationsWithLabels, setIndicationsWithLabels] = useState<Array<[IBaseViewModel, string]>>([]);

  useEffect(() => {
    const job = async (): Promise<void> => {
      const boxAvailableIndications: Array<[IBaseViewModel, string]> = [];
      for (const wfIndication of currentView.workflowIndications) {
        const viewModel = currentView.getItemByDescriptor(wfIndication.descriptor);
        const isResolved = await workflowIndicationsResolver.resolveWorkflowIndication(
          wfIndication.descriptor,
          wfIndication.isOptional
        );

        if (viewModel && isResolved) {
          boxAvailableIndications.push([viewModel, wfIndication.labelOverride ?? viewModel.label]);
        }
      }
      setIndicationsWithLabels(boxAvailableIndications);
    };
    void job();
  }, [workflowIndicationsResolver, currentView, currentView.workflowIndications.length]);
  return { indicationsWithLabels: indicationsWithLabels };
};
